module.exports = __webpack_public_path__ + "static/img/drone_06.bba6093.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/company/drone_06.jpg
// module id = 21FB
// module chunks = 0